import { Set } from "immutable";

import { isNativeAdminRoute } from "@sol/access-control";
import { checkFeatureFlag, Feature } from "@sol/features";
import { Route } from "@sol/routing";

/**
 * The brand scopes every answer the api gives, so it is shown where it decides what is listed:
 * the native administration, not the screens its holder browses as a regular user.
 */
export const isBrandScopeShown = (route: string) => isNativeAdminRoute(route as Route);

/** Changing it is reserved to whoever the api lets write it; everyone else only reads the scope. */
export const canChangeBrandScope = (features: Set<Feature>) => checkFeatureFlag(features, Feature.CURRENT_BRAND_WRITE);
